import React, {Component} from 'react'
import {style} from 'glamor'
import * as colors from '../../colors'
import Page from './Page'
import PageTitle from '../PageTitle'
import Thumb from '../ThumbRevealFit'
import getLayout from '../../utils/getLayout'

export default class extends Component {

  shouldComponentUpdate(){
    return false
  }

  render(){
    console.log(this.props)
    const Layout = getLayout(this.props.items.length)
    return (
      <Page
        {...style({
          height: '100%',
          paddingTop: '4rem',
          paddingBottom: '4rem',
        })}
      >
        <Layout>
          {this.props.items.map((item, i)=>(
            <Thumb
              data-animate
              title={item.title}
              image={`/images/thumbs/${item.image}`}
              to={`${this.props.url}/${item.id}/${item.items[0].id}`}
              key={i}
            />
          ))}
        </Layout>
      </Page>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/pages/GalleryDesktop.js
 **/